import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgDoctorMaleStethoscope = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M16.375 13.8725C17.8555 14.4897 19.1202 15.5312 20.01 16.8658C20.8997 18.2004 21.3747 19.7685 21.375 21.3725"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.12501 21.375C5.12362 20.2794 5.34445 19.1949 5.77416 18.1871C6.20386 17.1793 6.8335 16.2692 7.62501 15.5117"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.375 12.625V14.5C16.375 15.3288 16.0458 16.1237 15.4597 16.7097C14.8737 17.2958 14.0788 17.625 13.25 17.625C12.4212 17.625 11.6263 17.2958 11.0403 16.7097C10.4542 16.1237 10.125 15.3288 10.125 14.5V12.625"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.625 10.125C2.625 10.4565 2.7567 10.7745 2.99112 11.0089C3.22554 11.2433 3.54348 11.375 3.875 11.375C4.20652 11.375 4.52446 11.2433 4.75888 11.0089C4.9933 10.7745 5.125 10.4565 5.125 10.125C5.125 9.79348 4.9933 9.47554 4.75888 9.24112C4.52446 9.0067 4.20652 8.875 3.875 8.875C3.54348 8.875 3.22554 9.0067 2.99112 9.24112C2.7567 9.47554 2.625 9.79348 2.625 10.125V10.125Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.125 10.125C5.78804 10.125 6.42393 10.3884 6.89277 10.8572C7.36161 11.3261 7.625 11.962 7.625 12.625V19.5C7.625 19.9973 7.82254 20.4742 8.17417 20.8258C8.52581 21.1775 9.00272 21.375 9.5 21.375H11.375C11.8723 21.375 12.3492 21.1775 12.7008 20.8258C13.0525 20.4742 13.25 19.9973 13.25 19.5V17.625"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.875 7C8.875 7.57453 8.98816 8.14344 9.20803 8.67424C9.42789 9.20504 9.75015 9.68734 10.1564 10.0936C10.5627 10.4998 11.045 10.8221 11.5758 11.042C12.1066 11.2618 12.6755 11.375 13.25 11.375C13.8245 11.375 14.3934 11.2618 14.9242 11.042C15.455 10.8221 15.9373 10.4998 16.3436 10.0936C16.7498 9.68734 17.0721 9.20504 17.292 8.67424C17.5118 8.14344 17.625 7.57453 17.625 7C17.625 6.42547 17.5118 5.85656 17.292 5.32576C17.0721 4.79496 16.7498 4.31266 16.3436 3.90641C15.9373 3.50015 15.455 3.17789 14.9242 2.95803C14.3934 2.73816 13.8245 2.625 13.25 2.625C12.6755 2.625 12.1066 2.73816 11.5758 2.95803C11.045 3.17789 10.5627 3.50015 10.1564 3.90641C9.75015 4.31266 9.42789 4.79496 9.20803 5.32576C8.98816 5.85656 8.875 6.42547 8.875 7V7Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.47998 4.77917C10.1574 5.48186 10.9695 6.04071 11.8679 6.4223C12.7662 6.80389 13.7323 7.00037 14.7083 7.00001C15.6969 7.00029 16.6752 6.79896 17.5833 6.40834"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgDoctorMaleStethoscope.displayName = 'SvgDoctorMaleStethoscope';
export default SvgDoctorMaleStethoscope;
